import * as React from 'react';
import { IBoxProps } from '@lce/slice';

import * as Styled from './PriceSymbol.style';

export interface IPriceSymbolProps extends IBoxProps {
  isCentered?: boolean;
  currencyImage?: string | undefined;
}

const PriceSymbol: React.FC<IPriceSymbolProps> = ({ isCentered = false, currencyImage, ...props }) => (
  <Styled.PriceSymbol data-testid='PriceSymbol' isCentered={ isCentered } { ...props }>
    {currencyImage == undefined && <Styled.PriceSvg data-testid='price-svg' />}
    {currencyImage == 'asterisk' && <Styled.PriceSvgAskterisk data-testid='asterisk-price-svg' />}
  </Styled.PriceSymbol>
);

export default PriceSymbol;
